import { ApolloClient, InMemoryCache } from '@apollo/client';
import { RestLink } from 'apollo-link-rest';

export const apolloClient = new ApolloClient({
    link: new RestLink({
        uri: '',
    }),
    cache: new InMemoryCache(),
});
